/**
 * The two primary work modes shown in the left rail (spec §8; cue-forge-a26
 * consolidated the original five modes into two). Studio folds in QC + timing/sync
 * (all inline); Convert folds in single-and-batch conversion. There are no longer
 * any whole-route Pro gates — every Pro feature gates inline (spec §7.5).
 */
export const ROUTES = ['edit', 'convert'] as const;

export type Route = (typeof ROUTES)[number];

/** Human label for a route, as shown in the rail nav. */
export const ROUTE_LABELS: Record<Route, string> = {
  edit: 'Studio',
  convert: 'Convert',
};
